module.exports = __webpack_public_path__ + "img/mkt_sale_details.8144dd9b.svg";